import { Radio } from 'antd';
import React, { useCallback, useMemo } from 'react';

import FullPageLoader from '../../../foundation/components/full_page_loader/FullPageLoader';
import Modal from '../../../foundation/components/modal/Modal';
import ResizableTable from '../../../foundation/components/resizable_table/ResizableTable';
import { VariantTranscript } from '../redux';
import { useTranscriptListModalLogic } from './hooks';

type VariantLinkModalType = {
  closeModal: () => void;
  onChangePrimaryTranscript: (record: VariantTranscript) => void;
};

const TranscriptListModal = ({
  closeModal,
  onChangePrimaryTranscript,
}: VariantLinkModalType) => {
  // All logic extracted to custom hook for separation of concerns
  const {
    isLoading,
    isTranscriptsLoading,
    variant,
    dataSource,
    modalOpts,
    handleSaveChanges,
    getColumns,
  } = useTranscriptListModalLogic({
    closeModal,
    onChangePrimaryTranscript,
  });

  const renderThreshold = useCallback(
    (value: boolean, record: VariantTranscript) => {
      return (
        <div className="h-table-action-col">
          <span style={{ display: 'inline-block' }}>
            <Radio
              checked={value}
              onChange={() => {
                handleSaveChanges(record); // Ensure this function does not return or pass an object to React
              }}
            />
          </span>
        </div>
      );
    },
    [handleSaveChanges],
  );

  const columns = useMemo(
    () => getColumns(renderThreshold),
    [getColumns, renderThreshold],
  );

  return (
    <Modal {...modalOpts} className="h-transcript-list-modal">
      {isLoading && <FullPageLoader />}

      <div className="h-transcript-list-modal__content-wrapper">
        <div className="h-transcript-list-modal__instructions">
          Please select a transcript from the list to set it as the primary
          transcript for this variant.
        </div>
        <div className="h-transcript-list-modal__header">
          Transcript list for gene: {variant?.gene_symbol}
        </div>

        <ResizableTable
          className="h-transcript-list-modal__table"
          columns={columns}
          dataSource={dataSource}
          loading={isTranscriptsLoading}
          persistenceKey="transcript-list"
        />
      </div>
    </Modal>
  );
};

export default TranscriptListModal;
